import { render, staticRenderFns } from "./Style1.vue?vue&type=template&id=a3fc9ef0&"
import script from "./Style1.vue?vue&type=script&lang=js&"
export * from "./Style1.vue?vue&type=script&lang=js&"
import style0 from "./Style1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports